// スライダー
import slick from "slick-carousel";

export function idxFunc() {
  if (!$("#indexTop").length) return;

  const introMovie = document.querySelector("#introMovie");
  const introMovieControl = document.querySelector(".introVideoControl");

  if (introMovie && introMovieControl) {
    const updateMovieControl = () => {
      const isPaused = introMovie.paused || introMovie.ended;
      introMovieControl.classList.toggle("is-paused", isPaused);
      introMovieControl.setAttribute("aria-label", isPaused ? "動画を再生" : "動画を停止");
    };

    const toggleIntroMovie = () => {
      if (introMovie.paused || introMovie.ended) {
        if (introMovie.ended) introMovie.currentTime = 0;
        introMovie.play().catch(updateMovieControl);
      } else {
        introMovie.pause();
      }
    };

    introMovieControl.addEventListener("click", toggleIntroMovie);
    introMovie.addEventListener("click", toggleIntroMovie);

    introMovie.addEventListener("play", updateMovieControl);
    introMovie.addEventListener("pause", updateMovieControl);
    introMovie.addEventListener("ended", updateMovieControl);
    updateMovieControl();
  }

  // slideArea1
  const $slider1 = $(".slideArea1");

  if ($slider1.length && !$slider1.hasClass("slick-initialized")) {
    $slider1.slick({
       autoplay: true,
      autoplaySpeed: 5000,
      speed: 200,
      slidesToShow: 3,
      arrows: true,
      dots: true,
      fade: false,
      infinite: true,
      pauseOnTouchMove: false,
      centerMode: true,
      centerPadding: "0px",
      variableWidth: true,
      pauseOnHover: false,
      nextArrow: '<img src="/s/garrack/feature/mushokutensei2026/images/spec/spec-slide-next-arrow.svg" class="slide-arrow next-arrow">',
      prevArrow: '<img src="/s/garrack/feature/mushokutensei2026/images/spec/spec-slide-prev-arrow.svg" class="slide-arrow prev-arrow">',
    });

    // dotsにclass付与
    $slider1.find(".slick-dots li").each(function (index) {
      $(this).addClass(`dot-${index + 1}`);
    });
  }

  // slideArea2
  const $slider2 = $(".slideArea2");

  if ($slider2.length && !$slider2.hasClass("slick-initialized")) {
    $slider2.slick({
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 200,
      slidesToShow: 3,
      arrows: true,
      dots: true,
      fade: false,
      infinite: true,
      pauseOnTouchMove: false,
      centerMode: true,
      centerPadding: "0px",
      variableWidth: true,
      pauseOnHover: false,
      nextArrow: '<img src="/s/garrack/feature/mushokutensei2026/images/special/special-slide-next-arrow.svg" class="slide-arrow next-arrow">',
      prevArrow: '<img src="/s/garrack/feature/mushokutensei2026/images/special/special-slide-prev-arrow.svg" class="slide-arrow prev-arrow">',
    });

    // dotsにclass付与
    $slider2.find(".slick-dots li").each(function (index) {
      $(this).addClass(`dot-${index + 1}`);
    });
  }
}
